// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Q5fj","sidebarFooter":"Sidebar_sidebarFooter__s4Ij","buttonContainer":"Sidebar_buttonContainer__knl4"};